//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Radio,
  RadioGroup,
} from 'vant'
import { cloneDeep } from '@/utils/lodash'
import CInput from '../CInput'

export default {
  name: 'CRadio',

  components: {
    RadioGroup,
    Radio,
    CInput,
  },

  props: {
    value: {
      type: [
        String,
        Number,
        Array,
        Object,
      ],
    },

    valueName: {
      type: String,
      default: 'key',
    },

    labelFormat: {
      type: String,
      default: '{name}',
    },

    apiMethod: { type: Function },

    dataHook: { type: Function },

    params: {
      type: Object,
      default: () => ({}),
    },

    mode: {
      type: String,
      default: '',
    },

    list: {
      type: Array,
      default: () => ([]),
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    tree: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return { options: [] }
  },

  computed: {
    showName: {
      get () {
        return this.filterLable(this.options.filter((el) => el[this.valueName] === this.value)[0])
      },
      set (val) {

      },
    },
  },

  watch: {
    list: {
      deep: true,
      immediate: true,
      handler (v) {
        if (v) {
          this.options = cloneDeep(v)
        }
      },
    },

    value: {
      handler (val) {
        this.$emit('on-change', val, this.options)
      },
      deep: true,
    },
  },

  methods: {
    chooseType (item) {
      this.$emit('input', this.value, item)
    },

    filterLable (val) {
      return this.labelFormat.replace(/{[a-zA-Z]+}/g, (key) => val[key.replace(/[{}]/g, '')])
    },
  },
}
